(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pf-christmas-gift-finder"] && !Shopify.designMode) return;
  try {
    
/* Native links remain usable without JavaScript. No external libraries or tracking. */
if (!customElements.get('pf-christmas-gift-finder')) {
  class PFChristmasGiftFinder extends HTMLElement {
    connectedCallback() {
      this._initFrame = requestAnimationFrame(() => this.initialise());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this._initFrame);
      cancelAnimationFrame(this._layoutFrame);
      if (this._abort) this._abort.abort();
      if (this._observer) this._observer.disconnect();
      if (this._timers) this._timers.forEach((timer) => clearTimeout(timer));
      this._ready = false;
    }

    initialise() {
      if (this._ready || !this.isConnected) return;
      this._tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this._panels = Array.from(this.querySelectorAll('[data-panel]'));
      const tablist = this.querySelector('[data-tabs]');
      if (!tablist || !this._tabs.length) return;
      this._ready = true;
      this._abort = new AbortController();
      this._timers = new Map();
      const signal = this._abort.signal;
      tablist.setAttribute('role', 'tablist');
      tablist.setAttribute('aria-orientation', 'horizontal');

      this._tabs.forEach((tab) => {
        const panel = this.panelFor(tab.dataset.tab);
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panel.id);
        tab.addEventListener('click', (event) => {
          // Preserve normal link behaviours, including opening a fragment in a new tab.
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.activate(tab.dataset.tab);
        }, { signal });
        tab.addEventListener('keydown', (event) => this.onTabKey(event, tab), { signal });
      });

      this._panels.forEach((panel) => {
        const tab = this._tabs.find((item) => item.dataset.tab === panel.dataset.panel);
        const track = panel.querySelector('[data-track]');
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.setAttribute('tabindex', '0');
        panel.querySelector('[data-previous]').addEventListener('click', () => this.scrollCards(panel, -1), { signal });
        panel.querySelector('[data-next]').addEventListener('click', () => this.scrollCards(panel, 1), { signal });
        panel.querySelector('[data-expand]').addEventListener('click', () => this.toggleExpanded(panel), { signal });
        track.addEventListener('scroll', () => {
          clearTimeout(this._timers.get(panel));
          this._timers.set(panel, setTimeout(() => this.updateControls(panel), 130));
        }, { passive: true, signal });
        track.addEventListener('focusin', (event) => {
          if (!(event.target instanceof Element)) return;
          const card = event.target.closest('[data-gift-card]');
          if (!card || panel.hasAttribute('data-expanded')) return;
          this.revealCard(track, card);
        }, { signal });
      });

      this.addEventListener('shopify:block:select', (event) => {
        if (!(event.target instanceof Element)) return;
        const card = event.target.closest('[data-gift-card]');
        const panel = card && card.closest('[data-panel]');
        if (!panel) return;
        this.activate(panel.dataset.panel);
        requestAnimationFrame(() => this.revealCard(panel.querySelector('[data-track]'), card));
      }, { signal });

      this.setAttribute('data-enhanced', '');
      let initial = this.dataset.defaultTab;
      const deepLink = this._panels.find((panel) => `#${panel.id}` === window.location.hash);
      if (deepLink) initial = deepLink.dataset.panel;
      this.activate(initial, false);

      if ('ResizeObserver' in window) {
        this._observer = new ResizeObserver(() => {
          cancelAnimationFrame(this._layoutFrame);
          this._layoutFrame = requestAnimationFrame(() => {
            const active = this._panels.find((panel) => !panel.hidden);
            if (active) this.updateControls(active);
          });
        });
        this._observer.observe(this);
      } else {
        window.addEventListener('resize', () => {
          const active = this._panels.find((panel) => !panel.hidden);
          if (active) this.updateControls(active);
        }, { passive: true, signal });
      }
    }

    panelFor(key) {
      return this._panels.find((panel) => panel.dataset.panel === key);
    }

    activate(key, focusTab = false) {
      const selected = this._tabs.find((tab) => tab.dataset.tab === key) || this._tabs[0];
      this._tabs.forEach((tab) => {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.setAttribute('tabindex', active ? '0' : '-1');
        this.panelFor(tab.dataset.tab).hidden = !active;
      });
      if (focusTab) selected.focus({ preventScroll: true });
      const panel = this.panelFor(selected.dataset.tab);
      requestAnimationFrame(() => this.updateControls(panel));
    }

    onTabKey(event, tab) {
      const index = this._tabs.indexOf(tab);
      const rtl = getComputedStyle(this).direction === 'rtl';
      let next;
      if (event.key === 'ArrowRight') next = index + (rtl ? -1 : 1);
      else if (event.key === 'ArrowLeft') next = index + (rtl ? 1 : -1);
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = this._tabs.length - 1;
      else if (event.key === ' ' || event.key === 'Enter') {
        event.preventDefault();
        this.activate(tab.dataset.tab, true);
        return;
      } else return;
      event.preventDefault();
      const wrapped = (next + this._tabs.length) % this._tabs.length;
      this.activate(this._tabs[wrapped].dataset.tab, true);
    }

    scrollCards(panel, direction) {
      const button = panel.querySelector(direction > 0 ? '[data-next]' : '[data-previous]');
      if (button.getAttribute('aria-disabled') === 'true') return;
      const track = panel.querySelector('[data-track]');
      const cards = Array.from(track.children);
      if (!cards.length) return;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const step = cards[0].getBoundingClientRect().width + gap;
      const page = Math.max(1, Math.floor((track.clientWidth + gap) / step));
      const rtl = getComputedStyle(track).direction === 'rtl';
      track.scrollBy({
        left: step * page * direction * (rtl ? -1 : 1),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    revealCard(track, card) {
      const bounds = track.getBoundingClientRect();
      const item = card.getBoundingClientRect();
      let delta = 0;
      if (item.left < bounds.left + 4) delta = item.left - bounds.left - 4;
      else if (item.right > bounds.right - 4) delta = item.right - bounds.right + 4;
      // Move only this row; do not unexpectedly scroll the entire page.
      if (Math.abs(delta) > 1) track.scrollBy({ left: delta, behavior: 'auto' });
    }

    toggleExpanded(panel) {
      const expand = !panel.hasAttribute('data-expanded');
      const track = panel.querySelector('[data-track]');
      const button = panel.querySelector('[data-expand]');
      const previousTop = button.getBoundingClientRect().top;
      panel.toggleAttribute('data-expanded', expand);
      track.scrollLeft = 0;
      this.updateControls(panel);
      if (!expand) {
        requestAnimationFrame(() => {
          const shift = button.getBoundingClientRect().top - previousTop;
          // Keep the collapse button roughly in place after a tall grid contracts.
          if (Math.abs(shift) > 4) window.scrollBy({ top: shift, behavior: 'auto' });
        });
      }
    }

    updateControls(panel) {
      if (!this.isConnected || panel.hidden) return;
      const track = panel.querySelector('[data-track]');
      const controls = panel.querySelector('[data-controls]');
      const scrolling = panel.querySelector('[data-scroll-controls]');
      const expandButton = panel.querySelector('[data-expand]');
      const cards = Array.from(track.children);
      const expanded = panel.hasAttribute('data-expanded');
      const overflow = track.scrollWidth > track.clientWidth + 3;
      controls.hidden = !expanded && !overflow;
      scrolling.hidden = expanded;
      expandButton.setAttribute('aria-expanded', String(expanded));
      expandButton.textContent = expanded ? this.dataset.collapseLabel : `${this.dataset.showLabel} (${cards.length})`;
      if (expanded || !overflow || !cards.length) return;

      const view = track.getBoundingClientRect();
      const rtl = getComputedStyle(track).direction === 'rtl';
      const first = cards[0].getBoundingClientRect();
      const last = cards[cards.length - 1].getBoundingClientRect();
      const atStart = rtl ? first.right <= view.right + 3 : first.left >= view.left - 3;
      const atEnd = rtl ? last.left >= view.left - 3 : last.right <= view.right + 3;
      panel.querySelector('[data-previous]').setAttribute('aria-disabled', String(atStart));
      panel.querySelector('[data-next]').setAttribute('aria-disabled', String(atEnd));
      const visible = cards.map((card, index) => ({ bounds: card.getBoundingClientRect(), index }))
        .filter(({ bounds }) => Math.min(bounds.right, view.right) - Math.max(bounds.left, view.left) > bounds.width * .6)
        .map(({ index }) => index + 1);
      const text = visible.length ? `${visible[0]}–${visible[visible.length - 1]} of ${cards.length}` : `${cards.length} choices`;
      const counter = panel.querySelector('[data-position]');
      if (counter.textContent !== text) counter.textContent = text;
    }
  }
  customElements.define('pf-christmas-gift-finder', PFChristmasGiftFinder);
}
/* PlayFaire: scroll the Christmas hero link to the gift finder. */
if (!window.pfGiftFinderScrollReady) {
  window.pfGiftFinderScrollReady = true;

  document.addEventListener('click', function (event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey ||
        event.shiftKey || event.altKey) return;
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest('a[href="#christmas-gift-finder"]');
    if (!link || link.hasAttribute('download') ||
        (link.target && link.target !== '_self')) return;

    const anchor = document.getElementById('christmas-gift-finder');
    const section = anchor && anchor.closest('pf-christmas-gift-finder');
    if (!section) return;

    event.preventDefault();
    event.stopPropagation();

    /* Space for the sticky header: mobile / desktop, in pixels. */
    const offset = window.innerWidth < 768 ? 110 : 180;
    const top = Math.max(0,
      anchor.getBoundingClientRect().top + window.scrollY - offset
    );

    const reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    /* Move keyboard focus without causing a separate jump. */
    const heading = section.querySelector('.pf-cgf__heading');
    if (heading) {
      if (!heading.hasAttribute('tabindex')) {
        heading.setAttribute('tabindex', '-1');
        heading.addEventListener('blur', function () {
          heading.removeAttribute('tabindex');
        }, { once: true });
      }
      heading.focus({ preventScroll: true });
    }

    window.scrollTo({
      top: top,
      behavior: reduceMotion ? 'instant' : 'smooth'
    });
  }, true);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-doll-world-entry"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('pf-doll-world-entry')) return;
  class DollWorld extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this.querySelectorAll('[data-enhance]').forEach(el => { el.hidden = false; });
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.manualPause = false;
      this.animations = new Set();
      this.syncMotion = () => {
        this.motion = this.dataset.animations !== 'false' && !this.reduced.matches && !this.manualPause;
        this.dataset.motion = this.motion ? 'on' : 'off';
        const toggle = this.querySelector('[data-motion-toggle]');
        if (toggle) {
          toggle.setAttribute('aria-pressed', String(!this.motion));
          toggle.textContent = this.motion ? 'Pause movement' : 'Movement paused';
          toggle.disabled = this.reduced.matches || this.dataset.animations === 'false';
        }
        if (!this.motion) this.animations.forEach(a => a.cancel());
        this.entryTick?.();
        this.chapterTick?.();
      };
      this.reduced.addEventListener('change', this.syncMotion, options);
      this.syncMotion();
      this.setupEntrance(options);
      this.setupChapters(options);
      this.querySelector('[data-motion-toggle]')?.addEventListener('click', () => {
        this.manualPause = !this.manualPause;
        this.syncMotion();
      }, options);
      this.querySelectorAll('[data-mood-choice]').forEach(button => {
        button.addEventListener('click', () => {
          this.dataset.mood = button.dataset.moodChoice;
          this.querySelectorAll('[data-mood-choice]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
          this.emit('scene_mood', { mood: this.dataset.mood });
        }, options);
      });
      this.querySelectorAll('.dw-hotspot').forEach(details => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          this.querySelectorAll('.dw-hotspot').forEach(other => { if (other !== details) other.open = false; });
          this.emit('hotspot_open', { collection: details.dataset.collectionTitle });
        }, options);
      });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const open = this.querySelector('.dw-hotspot[open]');
        if (open) { open.open = false; open.querySelector('summary').focus(); }
      }, options);
      document.addEventListener('click', event => {
        this.querySelectorAll('.dw-hotspot[open]').forEach(d => { if (!d.contains(event.target)) d.open = false; });
      }, options);
      this.querySelectorAll('a[data-dw-link]').forEach(link => {
        link.addEventListener('click', () => this.emit('collection_click', {
          collection: link.dataset.dwLink,
          placement: link.dataset.placement || 'card'
        }), options);
      });
      // Content is visible before enhancement; no hidden initial state or loading gate.
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.animateOnce(entry.target, [{opacity:.8,transform:'translateY(16px)'},{opacity:1,transform:'translateY(0)'}], {duration:650,easing:'cubic-bezier(.2,.65,.3,1)'});
            this.observer.unobserve(entry.target);
          });
        }, {threshold:.12});
        this.querySelectorAll('[data-reveal]').forEach(el => this.observer.observe(el));
      }
      const scene = this.querySelector('.dw-scene picture');
      if (scene) this.animateOnce(scene, [{transform:'scale(1.035)'},{transform:'scale(1)'}], {duration:1300,easing:'ease-out'});
      // Shopify editor block selection: reveal a hotspot or scroll to its collection card.
      this.addEventListener('shopify:block:select', event => {
        const block = event.target.closest('[data-collection-card], [data-world-option]');
        if (block) block.scrollIntoView({block:'center',behavior:'auto'});
      }, options);
    }
    setupChapters(options) {
      const trims = Array.from(this.querySelectorAll('[data-chapter-trim]'));
      if (!trims.length) return;
      this.chapterTick = () => {
        if (this.chapterFrame) return;
        this.chapterFrame = requestAnimationFrame(() => {
          this.chapterFrame = 0;
          trims.forEach(trim => {
            const rect = trim.getBoundingClientRect();
            const active = this.motion && !window.Shopify?.designMode;
            if (active && (rect.bottom < 0 || rect.top > window.innerHeight)) return;
            const progress = Math.max(0,Math.min(1,(window.innerHeight-rect.top)/(window.innerHeight+rect.height)));
            trim.style.setProperty('--dw-trim-x', active ? (-8+progress*8)+'%' : '-4%');
          });
        });
      };
      window.addEventListener('scroll',this.chapterTick,{...options,passive:true});
      window.addEventListener('resize',this.chapterTick,options);
      window.addEventListener('pageshow',this.chapterTick,options);
      this.chapterTick();
    }
    setupEntrance(options) {
      this.entry = this.querySelector('[data-entry]');
      this.stage = this.querySelector('[data-entry-stage]');
      if (!this.entry || !this.stage) return;
      this.entryCopy = this.querySelector('.dw-entry-copy');
      this.entryTick = () => {
        if (this.entryFrame) return;
        this.entryFrame = requestAnimationFrame(() => {
          this.entryFrame = 0;
          this.updateEntrance();
        });
      };
      this.measureEntrance = () => {
        const height = this.stage.getBoundingClientRect().height;
        this.entryTravel = Math.max(1, window.innerHeight * (Number(this.dataset.entryLength) || 90) / 100);
        this.entry.style.setProperty('--dw-stage-height', height + 'px');
        this.entry.style.setProperty('--dw-travel', this.entryTravel + 'px');
        this.entryTick();
      };
      window.addEventListener('scroll', this.entryTick, {...options, passive:true});
      window.addEventListener('resize', this.measureEntrance, options);
      window.addEventListener('pageshow', this.measureEntrance, options);
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) { this.measureEntrance(); this.updateEntrance(); }
      }, options);
      if ('ResizeObserver' in window) {
        this.entryResize = new ResizeObserver(this.measureEntrance);
        this.entryResize.observe(this.stage);
      }
      this.querySelectorAll('[data-skip-entry]').forEach(link => {
        link.addEventListener('click', event => {
          const destination = this.querySelector('[id="' + this.id + '-collections"]');
          if (!destination) return;
          event.preventDefault();
          window.scrollTo({top:window.scrollY + destination.getBoundingClientRect().top,behavior:'instant'});
          this.updateEntrance();
          destination.focus({preventScroll:true});
          this.emit('entrance_skip', {});
        }, options);
      });
      this.measureEntrance();
    }
    entranceFrame(progress) {
      const clamp = x => Math.max(0, Math.min(1, x));
      const smooth = x => { x=clamp(x); return x*x*(3-2*x); };
      const p = clamp(progress);
      return {
        zoom: 1 + 2.8 * Math.pow(smooth((p-.08)/.82), 2),
        angle: -7 - 101 * smooth(p/.55),
        bloom: smooth((p-.55)/.30),
        stage: 1-smooth((p-.84)/.16),
        copy: 1-smooth(p/.23),
        glow: .35+.65*smooth(p/.5),
        scene: 1-smooth((p-.78)/.07)
      };
    }
    updateEntrance() {
      if (!this.entry) return;
      const enabled = this.motion && !window.Shopify?.designMode;
      this.entry.classList.toggle('is-active', enabled);
      this.entry.classList.toggle('is-static', !enabled);
      const progress = enabled ? Math.max(0,Math.min(1,-this.entry.getBoundingClientRect().top/(this.entryTravel||1))) : 0;
      const f = this.entranceFrame(progress);
      for (const [name,value] of Object.entries({zoom:f.zoom,angle:f.angle+'deg',bloom:f.bloom,copy:f.copy,glow:f.glow,'scene-opacity':f.scene,'stage-opacity':f.stage})) {
        this.entry.style.setProperty('--dw-'+name,String(value));
      }
      // Release the enlarged raster once covered, before it can linger offscreen.
      this.entry.style.setProperty('--dw-zoom',String(f.scene === 0 ? 1 : f.zoom));
      this.entry.classList.toggle('is-painting',enabled && progress > 0 && progress < .85);
      this.stage.inert = enabled && f.stage < .01;
      if (this.entryCopy) {
        this.entryCopy.classList.toggle('is-past',f.copy < .01);
        this.entryCopy.inert = f.copy < .01;
      }
      if (progress > .95 && !this.entranceReported) {
        this.entranceReported = true;
        this.emit('entrance_complete', {});
      }
    }
    animateOnce(element, frames, options) {
      if (!this.motion || typeof element.animate !== 'function') return;
      const animation = element.animate(frames, options);
      this.animations.add(animation);
      animation.finished.then(() => this.animations.delete(animation)).catch(() => this.animations.delete(animation));
    }
    emit(action, detail) {
      // Local event only. Connect to consent-aware analytics in the theme if desired.
      this.dispatchEvent(new CustomEvent('playfaire:doll-world', {bubbles:true,detail:{action,...detail}}));
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.entryResize?.disconnect();
      if (this.entryFrame) cancelAnimationFrame(this.entryFrame);
      this.entryFrame = 0;
      if (this.chapterFrame) cancelAnimationFrame(this.chapterFrame);
      this.chapterFrame = 0;
      this.animations?.forEach(a => a.cancel());
      this._connected = false;
    }
  }
  customElements.define('pf-doll-world-entry', DollWorld);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-worlds-doors"] && !Shopify.designMode) return;
  try {
    
(()=>{if(customElements.get('pf-worlds-doors'))return;
function setupDoorDetails(root,signal){
 const o={signal},reduce=root.reduced,swings=new Set();
 root.triggers.forEach(door=>{
  let swing;
  const play=()=>{if(reduce.matches||root.dataset.motion==='false'||root.dataset.signMotion==='false'||window.Shopify?.designMode||swing?.playState==='running')return;const plaque=door.querySelector('.editorial-plaque');if(plaque?.animate){swing=plaque.animate([{transform:'rotateX(0deg) rotateZ(0deg)'},{transform:'rotateX(-13deg) rotateZ(-1.1deg)',offset:.28},{transform:'rotateX(5deg) rotateZ(.5deg)',offset:.62},{transform:'rotateX(0deg) rotateZ(0deg)'}],{duration:1100,easing:'ease-in-out'});swings.add(swing);const current=swing;current.onfinish=()=>swings.delete(current);}};
  door.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')play()},o);
  door.addEventListener('pointerleave',()=>{swing?.cancel();swings.delete(swing)},o);
  door.addEventListener('focusout',()=>{swing?.cancel();swings.delete(swing)},o);
  door.addEventListener('focusin',play,o);
  door.addEventListener('pointerdown',e=>{if(e.pointerType==='touch'||e.pointerType==='pen')play()},o);
 });
 reduce.addEventListener('change',()=>{if(reduce.matches){swings.forEach(a=>a.cancel());swings.clear()}},o);
 signal.addEventListener('abort',()=>{swings.forEach(a=>a.cancel());swings.clear()},{once:true});
}

class Doors extends HTMLElement{
 connectedCallback(){if(this.abort)return;this.abort=new AbortController();const o={signal:this.abort.signal};this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.desktop=matchMedia('(min-width: 851px)');this.doorReturns=new WeakMap();this.triggers=[...this.querySelectorAll('[data-door]')];setupDoorDetails(this,this.abort.signal);
 this.addEventListener('click',e=>{const trigger=e.target.closest('summary.pfw-door-trigger');if(!trigger||!this.contains(trigger))return;
 e.preventDefault();const detail=trigger.parentElement,opening=!detail.open,before=trigger.getBoundingClientRect().top;
 if(opening)this.doorReturns.set(detail,scrollY);
 this.querySelectorAll('.pfw-door-disclosure[open]').forEach(other=>{if(other!==detail)other.open=false});detail.open=opening;
 const shift=trigger.getBoundingClientRect().top-before;if(Math.abs(shift)>1)window.scrollBy({top:shift,behavior:'instant'});
 if(opening&&!this.reduced.matches&&this.dataset.motion!=='false'){const panel=detail.querySelector('.pfw-door-navigation');panel.getAnimations?.().forEach(x=>x.cancel());panel.animate?.([{opacity:0,transform:'perspective(800px) rotateX(-7deg) translateY(-5px)'},{opacity:1,transform:'perspective(800px) rotateX(0deg) translateY(0)'}],{duration:340,easing:'cubic-bezier(.2,.8,.2,1)'});detail.querySelectorAll('.pfw-door-navigation a').forEach((a,i)=>{a.getAnimations?.().forEach(x=>x.cancel());a.animate?.([{opacity:0,translate:'0 6px'},{opacity:1,translate:'0 0'}],{duration:260,delay:70+i*35,fill:'backwards',easing:'ease-out'})})}
 this.scrollDoor(detail,opening);
 },o);
 this.addEventListener('keydown',e=>{if(e.key!=='Escape')return;const detail=e.target.closest('.pfw-door-disclosure[open]');if(detail){detail.open=false;detail.querySelector('summary').focus({preventScroll:true});this.scrollDoor(detail,false)}},o);

 document.addEventListener('shopify:block:select',e=>{const card=e.target.closest?.('[data-block-id]');if(card&&this.contains(card))this.revealDoorCard(card)},o);
 this.hall=this.querySelector('[data-hallway]');this.stage=this.querySelector('[data-hall-stage]');this.track=this.querySelector('[data-door-grid]');this.offset=Number(this.dataset.offset)||0;
 this.tick=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;this.paintHall()})};this.measure=()=>{this.lastPaint=null;const headerNodes=[...document.querySelectorAll('#shopify-section-header, .section-header, .shopify-section-group-header-group, body > header, sticky-header')];const headerBottom=headerNodes.reduce((bottom,node)=>{const r=node.getBoundingClientRect();return r.top<innerHeight/3&&r.bottom>0?Math.max(bottom,r.bottom):bottom},0);this.style.setProperty('--doors-header-clearance',Math.max(this.offset,Math.min(headerBottom,innerHeight*.4))+'px');this.walking=!this.querySelector('.pfw-door-disclosure')&&this.dataset.motion!=='false'&&this.dataset.hallway!=='false'&&!this.reduced.matches&&this.desktop.matches&&!window.Shopify?.designMode&&this.triggers.length>1&&innerHeight-this.offset>=640;this.style.setProperty('--hall-offset',this.offset+'px');this.hall.classList.toggle('is-walking',this.walking);if(this.walking&&this.track.getBoundingClientRect().height+105>this.stage.getBoundingClientRect().height){this.walking=false;this.hall.classList.remove('is-walking')}this.travel=Math.max(1,innerHeight*(Number(this.dataset.distance)||140)/100);this.distance=Math.max(0,this.track.scrollWidth-this.stage.clientWidth);if(this.walking&&this.distance<2){this.walking=false;this.hall.classList.remove('is-walking')}this.hall.style.setProperty('--hall-height',this.stage.getBoundingClientRect().height+'px');this.hall.style.setProperty('--hall-travel',this.travel+'px');this.querySelector('[data-hall-hint]').hidden=!this.walking;this.paintHall()};
 window.addEventListener('scroll',this.tick,{...o,passive:true});window.addEventListener('resize',this.measure,o);window.addEventListener('pageshow',this.measure,o);this.reduced.addEventListener('change',()=>{this.animation?.cancel();this.measure()},o);this.desktop.addEventListener('change',this.measure,o);this.resize=new ResizeObserver(this.measure);this.resize.observe(this.stage);this.resize.observe(this.track);// Pointer focus must not move a link between press and release.
 this.pointerFocus=false;
 document.addEventListener('pointerdown',()=>{this.pointerFocus=true},{...o,capture:true,passive:true});
 document.addEventListener('keydown',()=>{this.pointerFocus=false},{...o,capture:true});
 this.track.addEventListener('focusin',e=>{if(!this.pointerFocus&&e.target.matches(':focus-visible'))this.revealDoorCard(e.target)},o);
 this.measure();this.sceneAnimations=[];
 if(this.dataset.motion!=='false'&&!this.reduced.matches&&'IntersectionObserver' in window){this.sceneObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{if(!entry.isIntersecting)return;this.sceneObserver.unobserve(entry.target);const trail=entry.target.classList.contains('pfw-arrival-trail');const a=entry.target.animate?.(trail?[{clipPath:'inset(0 0 100% 0)'},{clipPath:'inset(0 0 0 0)'}]:[{opacity:.85,translate:'0 10px'},{opacity:1,translate:'0 0'}],{duration:trail?650:420,easing:'cubic-bezier(.2,.7,.2,1)'});if(a)this.sceneAnimations.push(a)}),{threshold:.15});this.querySelectorAll('.pfw-door-art,.pfw-arrival-trail').forEach(el=>this.sceneObserver.observe(el));this.reduced.addEventListener('change',()=>{if(this.reduced.matches)this.sceneAnimations.forEach(a=>a.cancel())},o)}
 this.peekAnimations=[];if(this.dataset.peek!=='false'&&this.dataset.motion!=='false'&&!window.Shopify?.designMode&&'IntersectionObserver' in window){this.peekObserver=new IntersectionObserver(entries=>entries.forEach(e=>{if(!e.isIntersecting)return;this.peekObserver.unobserve(e.target);if(!this.reduced.matches&&e.target.animate){const a=e.target.animate([{transform:'translateX(-50%)'},{transform:'translateX(-55%)'},{transform:'translateX(-50%)'}],{duration:1100,easing:'ease-in-out'});this.peekAnimations.push(a)}}),{threshold:.6});this.querySelectorAll('[data-peek-style="character"] img').forEach(img=>this.peekObserver.observe(img));this.reduced.addEventListener('change',()=>{if(this.reduced.matches)this.peekAnimations.forEach(a=>a.cancel())},o)}}

 // Reveal the directory on activation, preserving the user's place for closing.
 scrollDoor(detail,opening){
  if(window.Shopify?.designMode)return;
  const behavior=this.reduced.matches||this.dataset.motion==='false'?'instant':'smooth';
  if(!opening){const top=this.doorReturns.get(detail);if(Number.isFinite(top))window.scrollTo({top:Math.max(0,top),behavior});this.doorReturns.delete(detail);return}
  const panel=detail.querySelector('.pfw-door-navigation');if(!panel)return;
  const header=[...document.querySelectorAll('#shopify-section-header,#pageheader,.pageheader,.section-header,.shopify-section-group-header-group,sticky-header')].reduce((n,el)=>{const r=el.getBoundingClientRect();return r.top<innerHeight/3&&r.bottom>0?Math.max(n,Math.min(r.bottom,innerHeight*.4)):n},0);
  const rect=panel.getBoundingClientRect(),safeTop=header+72;
  // Keep the Close control above the menu and leave a margin below its links.
  const bottomOverflow=rect.bottom-(innerHeight-24);
  const topAllowance=rect.top-safeTop;
  // Move only enough to expose the final link. Oversized menus start below Close.
  const delta=topAllowance<0?topAllowance:Math.min(Math.max(0,bottomOverflow),topAllowance);
  if(Math.abs(delta)>1)window.scrollTo({top:Math.max(0,scrollY+delta),behavior});
 }
 // Keep keyboard-focused navigation visible without moving pointer targets.
 revealDoorCard(target){
  const card=target?.closest('[data-block-id]');if(!this.walking||!card)return;
  const x=Math.max(0,Math.min(this.distance,card.offsetLeft+card.offsetWidth/2-this.stage.clientWidth/2));
  const top=scrollY+this.hall.getBoundingClientRect().top-this.offset+(x/(this.distance||1))*this.travel;
  if(Math.abs(scrollY-top)>1)window.scrollTo({top,behavior:'instant'});
  this.paintHall();
 }
 paintHall(){if(!this.hall)return;const p=this.walking?Math.max(0,Math.min(1,(this.offset-this.hall.getBoundingClientRect().top)/this.travel)):0;const key=[p,this.distance].join(':');if(this.lastPaint===key)return;this.lastPaint=key;this.hall.style.setProperty('--hall-x',(-this.distance*p)+'px');this.hall.style.setProperty('--hall-progress',p)}
 disconnectedCallback(){this.abort?.abort();this.abort=null;this.animation?.cancel();this.resize?.disconnect();this.sceneObserver?.disconnect();this.sceneAnimations?.forEach(a=>a.cancel());this.peekObserver?.disconnect();this.peekAnimations?.forEach(a=>a.cancel());cancelAnimationFrame(this.frame);this.frame=0}
}customElements.define('pf-worlds-doors',Doors)})();

(()=>{if(window.PFWorldsReturn)return;window.PFWorldsReturn=true;
const key='pf-worlds:return:'+location.pathname+location.search;
function remember(){if(window.Shopify?.designMode)return;try{const worlds=[...document.querySelectorAll('pf-worlds-doors')].map(h=>({id:h.id,active:h.active||null}));const sets=[...document.querySelectorAll('pf-worlds-set')].map(s=>({id:s.id,rows:[...s.querySelectorAll('[data-set-item]')].map(r=>({variant:r.querySelector('[data-variant]')?.value,quantity:r.querySelector('[data-quantity]')?.value,picked:r.querySelector('[data-pick]')?.checked}))}));sessionStorage.setItem(key,JSON.stringify({time:Date.now(),y:scrollY,worlds,sets}))}catch{}}
function restore(event){if(event?.persisted||window.Shopify?.designMode)return;const nav=performance.getEntriesByType?.('navigation')[0];if(nav?.type!=='back_forward')return;let state;try{state=JSON.parse(sessionStorage.getItem(key)||'null')}catch{return}if(!state||Date.now()-state.time>3600000)return;requestAnimationFrame(()=>requestAnimationFrame(()=>{for(const w of state.worlds||[]){const h=document.getElementById(w.id);if(w.active&&h?.open&&h.active!==w.active)h.open(w.active,false)}for(const saved of state.sets||[]){const s=document.getElementById(saved.id);if(!s)continue;[...s.querySelectorAll('[data-set-item]')].forEach((r,i)=>{const v=saved.rows[i];if(!v)return;const sel=r.querySelector('[data-variant]'),q=r.querySelector('[data-quantity]'),c=r.querySelector('[data-pick]');if(sel&&[...sel.options].some(o=>o.value===v.variant&&!o.disabled)){sel.value=v.variant;s.variantChanged?.(r)}if(q)q.value=v.quantity;if(c)c.checked=!!v.picked});s.update?.()}scrollTo({top:Math.max(0,Number(state.y)||0),behavior:'instant'})}))}
document.addEventListener('click',e=>{if(e.target.closest?.('.pfw a[href]'))remember()},true);window.addEventListener('pf:cart-added',remember);window.addEventListener('pagehide',remember);window.addEventListener('pageshow',restore);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-worlds-entrance"] && !Shopify.designMode) return;
  try {
    
(()=>{if(customElements.get('pf-worlds-entrance'))return;
class Entrance extends HTMLElement{
 connectedCallback(){if(this.abort)return;this.lastPaint=null;this.abort=new AbortController();const opts={signal:this.abort.signal};this.entry=this.querySelector('[data-entry]');this.stage=this.querySelector('[data-entry-stage]');if(!this.entry||!this.stage)return;this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.tick=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;this.paint()})};this.measure=()=>{this.lastPaint=null;this.travel=Math.max(1,innerHeight*(Number(this.dataset.entryLength)||90)/100);this.entry.style.setProperty('--dw-travel',this.travel+'px');this.entry.style.setProperty('--dw-stage-height',this.stage.getBoundingClientRect().height+'px');this.paint()};window.addEventListener('scroll',this.tick,{...opts,passive:true});window.addEventListener('resize',this.measure,opts);window.addEventListener('pageshow',this.measure,opts);this.reduced.addEventListener('change',this.measure,opts);document.addEventListener('visibilitychange',this.measure,opts);this.resize=new ResizeObserver(this.measure);this.resize.observe(this.stage);this.measure()}
 paint(){const enabled=this.dataset.animations!=='false'&&!this.reduced.matches&&!window.Shopify?.designMode;this.entry.classList.toggle('is-active',enabled);this.entry.classList.toggle('is-static',!enabled);const p=enabled?Math.max(0,Math.min(1,-this.entry.getBoundingClientRect().top/this.travel)):0;const paintKey=[p,enabled].join(':');if(this.lastPaint===paintKey)return;this.lastPaint=paintKey;const smooth=x=>{x=Math.max(0,Math.min(1,x));return x*x*(3-2*x)};const scene=1-smooth((p-.84)/.1);const values={zoom:scene===0?1:1+3.4*Math.pow(smooth((p-.08)/.82),2),angle:(-7-101*smooth(p/.55))+'deg',bloom:smooth((p-.62)/.3),copy:1-smooth(p/.23),glow:.35+.65*smooth(p/.5),'scene-opacity':scene,'stage-opacity':1-smooth((p-.88)/.11)};Object.entries(values).forEach(([k,v])=>this.entry.style.setProperty('--dw-'+k,v));this.entry.classList.toggle('is-painting',enabled&&p>0&&p<.94);this.stage.inert=p>=.99;this.stage.style.visibility=p>=.99?'hidden':'visible';const copy=this.querySelector('.dw-entry-copy');copy.classList.toggle('is-past',values.copy<.01)}
 disconnectedCallback(){this.abort?.abort();this.abort=null;this.resize?.disconnect();cancelAnimationFrame(this.frame);this.frame=0}
}customElements.define('pf-worlds-entrance',Entrance)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-worlds-map"] && !Shopify.designMode) return;
  try {
    
(()=>{if(customElements.get('pf-worlds-map'))return;
const destinations={doors:'pf-worlds-doors',seasonal:'pf-worlds-spotlight',playroom:'pf-worlds-room',rosewood:'pf-worlds-showcase',soft:'pf-worlds-soft-dolls',finder:'pf-worlds-doll-finder',collections:'.pfw-collections'};
class WorldMap extends HTMLElement{
 connectedCallback(){if(this.abort)return;this.abort=new AbortController();const opts={signal:this.abort.signal};this.reduce=matchMedia('(prefers-reduced-motion: reduce)');this.grid=this.querySelector('.dw-map-grid');this.rail=this.querySelector('.dw-journey-rail');this.back=this.querySelector('.dw-map-return');this.current=this.querySelector('[data-current-stop]');this.entries=[];this.frame=0;
 this.overlay=document.createElement('div');this.overlay.className='pfw-map-overlay';['--map-paper','--map-sage'].forEach(k=>this.overlay.style.setProperty(k,this.style.getPropertyValue(k)));this.overlay.append(this.rail,this.back);document.body.appendChild(this.overlay);
 this.schedule=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;this.paint()})};
 this.refresh=()=>{this.headerClearance=Math.max(this.headerClearance||0,this.header());this.style.setProperty('--map-header-clearance',this.headerClearance+'px');this.entries=[];this.querySelectorAll('[data-destination]').forEach((link,i)=>{const target=link.dataset.targetId?document.getElementById(link.dataset.targetId):document.querySelector(destinations[link.dataset.destination]||'[data-no-destination]');link.hidden=!target;if(target){if(!target.id)target.id=this.id+'-destination-'+i;link.href='#'+target.id;this.entries.push({link,target,title:link.querySelector('.dw-map-name').textContent})}});this.entries.sort((a,b)=>a.target===b.target?0:(a.target.compareDocumentPosition(b.target)&Node.DOCUMENT_POSITION_FOLLOWING?-1:1));this.entries.forEach(entry=>this.grid.appendChild(entry.link));this.rail.querySelectorAll('.dw-rail-landmark').forEach(n=>n.remove());this.entries.forEach(entry=>{const marker=document.createElement('span');marker.className='dw-rail-landmark';const icon=entry.link.querySelector('svg');if(icon)marker.appendChild(icon.cloneNode(true));this.rail.appendChild(marker);entry.marker=marker});this.draw();this.schedule()};
 this.addEventListener('click',e=>{const link=e.target.closest('[data-destination]');if(!link||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.button>0)return;const entry=this.entries.find(x=>x.link===link);if(!entry)return;e.preventDefault();this.go(entry.target,link)},opts);
 this.back.addEventListener('click',()=>this.go(this),opts);
 window.addEventListener('scroll',this.schedule,{...opts,passive:true});window.addEventListener('resize',this.refresh,opts);window.addEventListener('pageshow',this.refresh,opts);document.addEventListener('shopify:section:load',this.refresh,opts);document.addEventListener('shopify:section:unload',this.refresh,opts);document.addEventListener('shopify:section:reorder',this.refresh,opts);
 this.observer=new ResizeObserver(()=>{this.draw();this.schedule()});this.observer.observe(this.grid);this.refresh();document.fonts?.ready.then(()=>{if(this.isConnected)this.refresh()});
 }
 header(){return [...document.querySelectorAll('#shopify-section-header,#pageheader,.pageheader,.section-header,.shopify-section-group-header-group,body > header,sticky-header')].reduce((n,el)=>{const r=el.getBoundingClientRect();return r.top<innerHeight/3&&r.bottom>0?Math.max(n,Math.min(r.bottom,innerHeight*.4)):n},0)}
 go(target,link){
 this.travel?.cancel();this.arrival?.cancel();
 const heading=target.querySelector('h2,h3')||target;
 let top=Math.max(0,scrollY+(target===this?heading:target).getBoundingClientRect().top-this.header()-20);
 if(target===this){const entry=document.querySelector('pf-worlds-entrance .dw-entry.is-active');const stage=entry?.querySelector('[data-entry-stage]');if(entry&&stage)top=Math.max(top,scrollY+entry.getBoundingClientRect().top+entry.getBoundingClientRect().height-stage.getBoundingClientRect().height+2);}
 const finish=()=>{if(!heading.hasAttribute('tabindex'))heading.setAttribute('tabindex','-1');heading.focus({preventScroll:true});this.schedule();if(target!==this&&!this.reduce.matches&&heading.animate)this.arrival=heading.animate([{opacity:.7,transform:'translateY(7px)'},{opacity:1,transform:'translateY(0)'}],{duration:320,easing:'ease-out'})};
 if(target===this||this.reduce.matches){window.scrollTo({top,behavior:'instant'});finish();return}
 if(link?.querySelector('.dw-map-picture')?.animate)link.querySelector('.dw-map-picture').animate([{transform:'scale(.97)'},{transform:'scale(1.08)'},{transform:'scale(1)'}],{duration:280,easing:'ease-out'});
 const from=scrollY,distance=top-from;
 // Long trips skip intermediate scroll scenes; nearby destinations glide in.
 if(Math.abs(distance)>innerHeight*1.4){window.scrollTo({top,behavior:'instant'});finish();return}
 let frame=0,start=null,cancelled=false;
 const cancel=()=>{cancelled=true;cancelAnimationFrame(frame);window.removeEventListener('wheel',cancel);window.removeEventListener('touchstart',cancel);window.removeEventListener('keydown',cancel)};
 this.travel={cancel};window.addEventListener('wheel',cancel,{passive:true,once:true});window.addEventListener('touchstart',cancel,{passive:true,once:true});window.addEventListener('keydown',cancel,{once:true});
 const step=time=>{if(cancelled)return;if(start===null)start=time;const t=Math.min(1,(time-start)/420);window.scrollTo({top:from+distance*(1-Math.pow(1-t,3)),behavior:'instant'});if(t<1)frame=requestAnimationFrame(step);else{cancel();finish()}};
 frame=requestAnimationFrame(step);
 }
 draw(){const bounds=this.grid.getBoundingClientRect();const points=this.entries.map(x=>{const r=x.link.querySelector('.dw-map-picture').getBoundingClientRect();return {x:r.left-bounds.left+r.width/2,y:r.top-bounds.top+r.height/2}});let d='';points.forEach((p,i)=>{if(!i){d='M'+p.x+' '+p.y;return}const prev=points[i-1],mid=(prev.y+p.y)/2;d+=' C'+prev.x+' '+mid+' '+p.x+' '+mid+' '+p.x+' '+p.y});this.querySelector('.dw-map-route path').setAttribute('d',d)}
 paint(){if(!this.entries.length){this.back.hidden=true;this.rail.hidden=true;return}const offset=this.header()+28;this.overlay.style.setProperty('--journey-top',offset+'px');const ordered=this.entries.map(x=>({...x,rect:x.target.getBoundingClientRect()})).sort((a,b)=>a.rect.top-b.rect.top);const start=ordered[0].rect.top+scrollY;const contentEnd=Math.max(...ordered.map(x=>x.rect.bottom+scrollY));const footer=document.querySelector('#shopify-section-footer,footer,.section-footer');const footerTop=footer?footer.getBoundingClientRect().top+scrollY:Infinity;const end=Math.min(contentEnd,footerTop);this.overlay.style.setProperty('--journey-bottom',Math.max(72,innerHeight-(end-scrollY)+16)+'px');const position=scrollY+offset;const p=Math.max(0,Math.min(1,(position-start)/Math.max(1,end-start-innerHeight+offset)));this.overlay.style.setProperty('--journey-progress',p);this.entries.forEach(x=>{const y=x.target.getBoundingClientRect().top+scrollY;const progress=Math.max(0,Math.min(1,(y-start)/Math.max(1,end-start-innerHeight+offset)));x.marker.style.top=(progress*100)+'%';x.marker.classList.toggle('is-reached',position>=y)});let active=ordered[0];ordered.forEach(x=>{if(x.rect.top<=offset+innerHeight*.25)active=x});this.entries.forEach(x=>{if(x.target===active.target)x.link.setAttribute('aria-current','location');else x.link.removeAttribute('aria-current')});this.current.textContent=active.title;const visible=this.getBoundingClientRect().bottom<offset&&end-scrollY>offset+60;this.back.hidden=!visible||end-scrollY<innerHeight;this.rail.hidden=!visible||this.dataset.path==='false'||!!window.Shopify?.designMode;}
 disconnectedCallback(){this.travel?.cancel();this.arrival?.cancel();this.abort?.abort();this.abort=null;this.observer?.disconnect();cancelAnimationFrame(this.frame);if(this.overlay){this.append(this.rail,this.back);this.overlay.remove();this.overlay=null}}
}customElements.define('pf-worlds-map',WorldMap)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-worlds-room"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('pf-worlds-room')) return;
  class ShopRoom extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.points = [...this.querySelectorAll('[data-hotspot]')];
      this.cards = [...this.querySelectorAll('[data-room-product]')];
      this.picks = [...this.querySelectorAll('[data-room-pick]')];
      this.navigation = this.querySelector('[data-room-navigation]');
      this.compact = this.dataset.productLayout !== 'list';
      this.dataset.roomSize = this.cards.length > 6 ? 'large' : 'regular';
      this.classList.toggle('is-compact', this.compact && this.cards.length > 0);
      this.navigation.hidden = !this.compact || this.cards.length < 2;
      this.points.forEach(point => {
        point.setAttribute('role', 'button');
        point.addEventListener('click', event => {
          event.preventDefault();
          this.choose(point.dataset.hotspot, true);
        }, options);
        point.addEventListener('keydown', event => {
          if (event.key !== ' ') return;
          event.preventDefault();
          this.choose(point.dataset.hotspot, true);
        }, options);
      });
      this.picks.forEach((pick, index) => {
        pick.addEventListener('click', () => this.choose(pick.dataset.roomPick, false), options);
        pick.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          const columns = this.dataset.roomSize === 'large' ? 4 : Math.max(1, getComputedStyle(pick.parentElement).gridTemplateColumns.trim().split(/\s+/).length);
          const targets = { ArrowLeft: index - 1, ArrowRight: index + 1, ArrowUp: index - columns, ArrowDown: index + columns, Home: 0, End: this.picks.length - 1 };
          const next = this.picks[Math.max(0, Math.min(this.picks.length - 1, targets[event.key]))];
          event.preventDefault();
          next.focus({ preventScroll: true });
          this.choose(next.dataset.roomPick, false);
        }, options);
      });
      document.addEventListener('shopify:block:select', event => {
        const target = event.target.closest?.('[data-room-product]');
        const card = target && this.contains(target) ? target : this.cards.find(item => item.dataset.roomProduct === event.detail?.blockId);
        if (card) this.choose(card.dataset.roomProduct, false);
      }, options);
      if (this.cards[0]) this.choose(this.cards[0].dataset.roomProduct, false, false);
    }
    choose(id, move, announce = true) {
      const card = this.cards.find(item => item.dataset.roomProduct === id);
      if (!card) return;
      this.cards.forEach(item => {
        const inactive = this.compact && item !== card;
        item.classList.toggle('is-chosen', item === card);
        item.toggleAttribute('inert', inactive);
        if (inactive) item.setAttribute('aria-hidden', 'true');
        else item.removeAttribute('aria-hidden');
      });
      this.points.forEach(point => point.setAttribute('aria-pressed', String(point.dataset.hotspot === id)));
      this.picks.forEach(pick => pick.setAttribute('aria-pressed', String(pick.dataset.roomPick === id)));
      this.querySelector('[data-room-count]').textContent = `${this.cards.indexOf(card) + 1} / ${this.cards.length}`;
      if (announce && !move) this.querySelector('[data-room-status]').textContent = card.querySelector('h3').textContent;
      if (move) {
        card.focus({ preventScroll: true });
        if (matchMedia('(max-width:760px)').matches) card.scrollIntoView({ block: 'nearest', behavior: 'auto' });
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.classList.remove('is-compact');
      this.cards?.forEach(card => { card.removeAttribute('inert'); card.removeAttribute('aria-hidden'); });
      if (this.navigation) this.navigation.hidden = true;
    }
  }
  customElements.define('pf-worlds-room', ShopRoom);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-worlds-set"] && !Shopify.designMode) return;
  try {
    
(()=>{if(customElements.get('pf-worlds-set'))return;
class WorldSet extends HTMLElement{
 connectedCallback(){if(this.abort)return;this.abort=new AbortController();const o={signal:this.abort.signal};this.rows=[...this.querySelectorAll('[data-set-item]')];this.button=this.querySelector('[data-add-selected]');this.status=this.querySelector('[data-set-status]');this.review=this.querySelector('[data-review-cart]');this.idle=this.button.textContent;this.busy=false;this.uncertain=false;this.rows.forEach(r=>{const c=r.querySelector('[data-pick]');if(c)c.disabled=false});this.querySelector('[data-set-summary]').hidden=false;this.addEventListener('change',e=>{if(e.target.matches('[data-variant]'))this.variantChanged(e.target.closest('[data-set-item]'));this.update()},o);this.addEventListener('input',()=>this.update(),o);this.button.addEventListener('click',()=>this.add(),o);window.addEventListener('pageshow',()=>{this.busy=false;this.uncertain=false;this.lock(false);this.update()},o);this.update()}
 variantChanged(row){const select=row.querySelector('[data-variant]'),option=select.options[select.selectedIndex],q=row.querySelector('[data-quantity]');q.min=option.dataset.min||'1';q.step=option.dataset.step||'1';if(option.dataset.max)q.max=option.dataset.max;else q.removeAttribute('max');q.value=q.min;row.querySelector('[data-unit-price]').textContent=option.dataset.money}
 selection(){return this.rows.flatMap(r=>{if(!r.querySelector('[data-pick]')?.checked)return [];const select=r.querySelector('[data-variant]'),v=select?.options[select.selectedIndex],q=r.querySelector('[data-quantity]');return v&&!v.disabled?[{id:v.value,quantity:Number(q.value),price:Number(v.dataset.price),input:q}]:[]})}
 valid(items){return items.length>0&&items.every(x=>Number.isInteger(x.quantity)&&x.quantity>=Number(x.input.min||1)&&(!x.input.max||x.quantity<=Number(x.input.max))&&(x.quantity-Number(x.input.min||1))%Number(x.input.step||1)===0)}
 update(){const items=this.selection(),sum=items.reduce((n,x)=>n+(Number.isFinite(x.quantity)?x.quantity:0)*x.price,0);try{this.querySelector('[data-total]').textContent=new Intl.NumberFormat(document.documentElement.lang||'en-GB',{style:'currency',currency:this.dataset.currency||'GBP'}).format(sum/100)}catch{this.querySelector('[data-total]').textContent=(sum/100).toFixed(2)}this.button.disabled=this.busy||this.uncertain||!this.valid(items);if(!this.busy&&!this.uncertain)this.status.textContent=items.length?'':this.dataset.empty}
 lock(value){this.querySelectorAll('input,select').forEach(x=>x.disabled=value);this.button.textContent=value?this.dataset.busy:this.idle;this.setAttribute('aria-busy',String(value))}
 async add(){if(this.busy||this.uncertain)return;const chosen=this.selection();if(!this.valid(chosen))return;if(window.Shopify?.designMode){this.status.textContent='Open the theme preview in a new tab to test basket additions.';return}this.busy=true;this.lock(true);this.button.disabled=true;this.status.textContent='';this.review.hidden=true;
 const request=new AbortController();this.request=request;const timeout=setTimeout(()=>request.abort(),15000);
 const merged=new Map();chosen.forEach(({id,quantity})=>merged.set(id,(merged.get(id)||0)+quantity));
 try{const response=await fetch(this.dataset.add,{signal:request.signal,method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[...merged].map(([id,quantity])=>({id,quantity}))})});let result;try{result=await response.json()}catch{throw new Error(this.dataset.error)}if(!response.ok)throw new Error(typeof result.description==='string'?result.description:this.dataset.error);if(this.request!==request||!this.isConnected)return;window.dispatchEvent(new CustomEvent('pf:cart-added',{detail:{items:result.items||[]}}));window.location.assign(this.dataset.cart)}catch(error){if(this.request!==request||!this.isConnected)return;this.uncertain=true;this.status.textContent=(error.name!=='AbortError'&&error.message&&error.message!==this.dataset.error?error.message+' ':'')+this.dataset.error;this.review.hidden=false;this.busy=false;this.lock(false);this.update()}finally{clearTimeout(timeout);if(this.request===request)this.request=null}}
 disconnectedCallback(){this.request?.abort();this.request=null;this.abort?.abort();this.abort=null}
}customElements.define('pf-worlds-set',WorldSet)})();

(()=>{if(window.PFWorldsReturn)return;window.PFWorldsReturn=true;
const key='pf-worlds:return:'+location.pathname+location.search;
function remember(){if(window.Shopify?.designMode)return;try{const worlds=[...document.querySelectorAll('pf-worlds-doors')].map(h=>({id:h.id,active:h.active||null}));const sets=[...document.querySelectorAll('pf-worlds-set')].map(s=>({id:s.id,rows:[...s.querySelectorAll('[data-set-item]')].map(r=>({variant:r.querySelector('[data-variant]')?.value,quantity:r.querySelector('[data-quantity]')?.value,picked:r.querySelector('[data-pick]')?.checked}))}));sessionStorage.setItem(key,JSON.stringify({time:Date.now(),y:scrollY,worlds,sets}))}catch{}}
function restore(event){if(event?.persisted||window.Shopify?.designMode)return;const nav=performance.getEntriesByType?.('navigation')[0];if(nav?.type!=='back_forward')return;let state;try{state=JSON.parse(sessionStorage.getItem(key)||'null')}catch{return}if(!state||Date.now()-state.time>3600000)return;requestAnimationFrame(()=>requestAnimationFrame(()=>{for(const w of state.worlds||[]){const h=document.getElementById(w.id);if(w.active&&h?.open&&h.active!==w.active)h.open(w.active,false)}for(const saved of state.sets||[]){const s=document.getElementById(saved.id);if(!s)continue;[...s.querySelectorAll('[data-set-item]')].forEach((r,i)=>{const v=saved.rows[i];if(!v)return;const sel=r.querySelector('[data-variant]'),q=r.querySelector('[data-quantity]'),c=r.querySelector('[data-pick]');if(sel&&[...sel.options].some(o=>o.value===v.variant&&!o.disabled)){sel.value=v.variant;s.variantChanged?.(r)}if(q)q.value=v.quantity;if(c)c.checked=!!v.picked});s.update?.()}scrollTo({top:Math.max(0,Number(state.y)||0),behavior:'instant'})}))}
document.addEventListener('click',e=>{if(e.target.closest?.('.pfw a[href]'))remember()},true);window.addEventListener('pf:cart-added',remember);window.addEventListener('pagehide',remember);window.addEventListener('pageshow',restore);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-worlds-showcase"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('pf-worlds-showcase')) return;
  const clamp = x => Math.min(1, Math.max(0, x));
  const ease = x => { x = clamp(x); return x * x * (3 - 2 * x); };
  const between = (p, a, b) => ease((p - a) / (b - a));
  const mix = (a, b, t) => a + (b - a) * t;
  class RosewoodShowcase extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.journey = this.querySelector('[data-rosewood-journey]');
      this.stage = this.querySelector('[data-rosewood-stage]');
      this.story = this.querySelector('[data-rosewood-story]');
      this.photo = this.querySelector('[data-rosewood-photo]');
      this.copy = this.querySelector('[data-rosewood-copy]');
      this.skip = this.querySelector('[data-rosewood-skip]');
      this.viewport = this.querySelector('[data-rosewood-viewport]');
      this.caption = this.querySelector('.pfw-rosewood-caption');
      this.headers = [...document.querySelectorAll('#shopify-section-header, .section-header, .shopify-section-group-header-group, body > header, sticky-header')];
      this.reveals = [...this.querySelectorAll('[data-rosewood-reveal]')];
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.frame = 0; this.needsMeasure = true; this.lastPaint = null;
      const options = { signal: this.abort.signal };
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (this.needsMeasure) { this.needsMeasure = false; this.measure(); }
          this.update();
        });
      };
      this.resize = () => { this.needsMeasure = true; this.schedule(); };
      this.onSkip = () => {
        if (!this.enabled) return;
        const top = scrollY + this.journey.getBoundingClientRect().top - this.offset + this.travel;
        window.scrollTo({ top, behavior: 'instant' });
        this.paint(1);
        const title = this.querySelector('[data-rosewood-title]');
        if (title) title.focus({ preventScroll: true });
      };
      this.skip?.addEventListener('click', this.onSkip, options);
      window.addEventListener('scroll', this.schedule, { ...options, passive: true });
      window.addEventListener('resize', this.resize, options);
      window.addEventListener('pageshow', this.resize, options);
      this.reduced.addEventListener('change', this.resize, options);
      if (typeof ResizeObserver !== 'undefined') {
        this.observer = new ResizeObserver(this.resize);
        this.observer.observe(this.story);
        this.headers.forEach(header => this.observer.observe(header));
      }
      document.fonts?.ready.then(() => { if (this.abort) this.resize(); });
      // Synchronous first measurement preserves the opaque window-only first paint.
      this.measure(); this.update();
    }
    headerClearance() {
      // Reserve the complete sticky header, including its navigation row.
      // Use its settled height so hide-on-scroll transforms cannot jolt the scene.
      return this.headers.reduce((height, header) => {
        const css = getComputedStyle(header);
        const top = parseFloat(css.top);
        if (!['sticky', 'fixed', '-webkit-sticky'].includes(css.position)
          || !Number.isFinite(top) || css.display === 'none' || css.visibility === 'hidden') return height;
        return Math.max(height, Math.max(0, top) + header.getBoundingClientRect().height);
      }, 0);
    }
    measure() {
      this.enabled = this.dataset.window === 'true' && this.dataset.hasImage === 'true'
        && this.dataset.motion !== 'false' && this.dataset.windowMotion !== 'false'
        && this.dataset.editor !== 'true' && !window.Shopify?.designMode && !this.reduced.matches;
      this.classList.toggle('is-cinematic', this.enabled);
      this.skip.hidden = !this.enabled;
      if (!this.enabled) { this.copy.inert = false; this.lastPaint = null; return; }
      this.offset = Math.min(innerHeight * .40, Math.max(this.headerClearance(), Number(this.dataset.offset) || 0));
      this.style.setProperty('--rose-offset', this.offset + 'px');
      // 100svh is stable while mobile browser chrome expands/collapses.
      const sceneHeight = this.viewport.getBoundingClientRect().height || Math.max(1, innerHeight - this.offset);
      this.style.setProperty('--rose-scene-height', sceneHeight + 'px');
      const gutter = Math.min(56, Math.max(24, sceneHeight * .055));
      const captionSpace = this.caption
        ? this.caption.getBoundingClientRect().height + (parseFloat(getComputedStyle(this.caption).marginTop) || 0) : 0;
      this.style.setProperty('--rose-gutter', gutter + 'px');
      // Fit the desktop photo and its caption inside the usable viewing area.
      // Long copy and stacked mobile layouts retain their natural scroll height.
      this.style.setProperty('--rose-photo-size', Math.max(1, sceneHeight - gutter * 2 - captionSpace) + 'px');
      const stageHeight = Math.max(sceneHeight, this.story.getBoundingClientRect().height);
      this.style.setProperty('--rose-stage-height', stageHeight + 'px');
      const pace = Math.min(180, Math.max(60, Number(this.dataset.distance) || 100)) / 100;
      this.travel = sceneHeight * 2.2 * pace;
      this.style.setProperty('--rose-travel', this.travel + 'px');
      const stage = this.stage.getBoundingClientRect();
      const diameter = Math.min(460, stage.width * .72, sceneHeight * .60);
      this.style.setProperty('--rose-diameter', diameter+'px');
      this.geometry = {
        width:stage.width, sceneHeight, diameter,
        // The camera enters the upper-right pane, avoiding the central crossbar.
        // A clear disc of radius .15D around that point covers every viewport.
        fullScale:Math.max(10,Math.hypot(stage.width,sceneHeight)/(diameter*.30)),
      };
      this.lastPaint = null;
    }
    update() {
      if (!this.enabled) return;
      // Progress starts only when the section reaches its sticky position.
      const p = clamp((this.offset - this.journey.getBoundingClientRect().top) / this.travel);
      this.paint(p);
    }
    paint(p) {
      if (!this.geometry || this.lastPaint === p) return;
      this.lastPaint = p; this.progress = p;
      const g = this.geometry;
      // Graphic only -> travel through a pane -> brief opaque light -> house.
      // No photograph or wording participates in the entrance animation.
      const enter = between(p,.08,.55);
      const photo = between(p,.58,.76);
      const values = {
        'camera-scale':mix(1,g.fullScale,Math.pow(enter,1.65)),
        'camera-x':(-g.diameter*.19*enter)+'px',
        'camera-y':(g.diameter*.19*enter)+'px',
        'light-opacity':between(p,.47,.55),
        'entrance-visibility':p<.58?'visible':'hidden',
        'cue-opacity':1-between(p,.02,.08),
        'photo-opacity':photo,
        'photo-visibility':photo===0?'hidden':'visible',
        'photo-shift':(20*(1-photo))+'px',
      };
      Object.entries(values).forEach(([key,value]) => this.style.setProperty('--rose-'+key,String(value)));
      this.classList.toggle('is-arrived',p>=.84);
      const stages = {kicker:[.61,.74],title:[.63,.78],body:[.66,.81],actions:[.69,.84],extra:[.69,.84],caption:[.68,.80]};
      this.reveals.forEach(el=>{
        const [a,b]=stages[el.dataset.rosewoodReveal];
        const t=between(p,a,b);
        el.style.setProperty('--rose-word-opacity',String(t));
        el.style.setProperty('--rose-word-shift',(16*(1-t))+'px');
        el.style.setProperty('--rose-word-visibility',t===0?'hidden':'visible');
      });
      this.copy.inert=p<.84;
      this.skip.hidden=p>=.84;
    }
    disconnectedCallback() {
      this.skip?.removeEventListener('click',this.onSkip);
      this.abort?.abort(); this.abort=null;
      this.observer?.disconnect(); cancelAnimationFrame(this.frame); this.frame=0;
      if(this.copy) this.copy.inert=false;
    }
  }
  customElements.define('pf-worlds-showcase',RosewoodShowcase);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-worlds-soft-dolls"] && !Shopify.designMode) return;
  try {
    
(()=>{if(customElements.get('pf-worlds-soft-dolls'))return;class SoftDolls extends HTMLElement{
connectedCallback(){if(this.abort)return;this.abort=new AbortController();this.animations=[];this.reduce=matchMedia('(prefers-reduced-motion: reduce)');const stop=()=>{this.observer?.disconnect();this.animations.forEach(a=>a.cancel());this.animations=[]};this.reduce.addEventListener('change',e=>{if(e.matches)stop()},{signal:this.abort.signal});if(this.reduce.matches||this.dataset.motion==='false'||window.Shopify?.designMode||!('IntersectionObserver' in window))return;this.observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(!entry.isIntersecting)return;this.observer.unobserve(entry.target);const index=[...this.querySelectorAll('.cc-card')].indexOf(entry.target);if(entry.target.animate)this.animations.push(entry.target.animate([{opacity:.65,transform:'translateY(10px)'},{opacity:1,transform:'translateY(0)'}],{duration:440,delay:(index%2)*55,easing:'cubic-bezier(.2,.8,.2,1)'}))})},{threshold:.12});this.querySelectorAll('.cc-card').forEach(card=>this.observer.observe(card))}
disconnectedCallback(){this.abort?.abort();this.abort=null;this.observer?.disconnect();this.animations?.forEach(a=>a.cancel())}
}customElements.define('pf-worlds-soft-dolls',SoftDolls)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-worlds-spotlight"] && !Shopify.designMode) return;
  try {
    
(()=>{if(customElements.get('pf-worlds-spotlight'))return;class Spotlight extends HTMLElement{connectedCallback(){if(this.abort)return;this.abort=new AbortController();const o={signal:this.abort.signal};const track=this.querySelector('[data-track]');if(!track)return;const previous=this.querySelector('[data-prev]'),next=this.querySelector('[data-next]'),tools=this.querySelector('[data-carousel-tools]');const update=()=>{tools.hidden=track.scrollWidth<=track.clientWidth+2;previous.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2};previous.addEventListener('click',()=>track.scrollBy({left:-track.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}),o);next.addEventListener('click',()=>track.scrollBy({left:track.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}),o);track.addEventListener('scroll',update,{...o,passive:true});this.resize=new ResizeObserver(update);this.resize.observe(track);update()}disconnectedCallback(){this.abort?.abort();this.abort=null;this.resize?.disconnect()}}customElements.define('pf-worlds-spotlight',Spotlight)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }

  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};

document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});

loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
